module.exports = __webpack_public_path__ + "71b77c89a79c5e46d08c44414616cdeb.png";